import Solution from "./solution";
import compare from "../../Utils/compare";

const testCases = [
  {
    str: "ab",
  },
  {
    str: "ymdadmt",
  },
  {
    str: "abca",
  },
  {
    str: "abc",
  },
  {
    str: "ABCDCBA",
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { str } = test;
      let outcome1 = output()(str);
      let outcome2 = Solution(str);
      const result = outcome1 === outcome2;
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
